/** @jsx jsx */
import React from 'react';
import { css, jsx, SerializedStyles } from '@emotion/core';
import BaseButton, { ButtonProps } from './BaseButton';
import { PrimaryButton } from "components/atoms/Button";
import FlexBox from "components/atoms/FlexBox";
import FlexBoxItem from "components/atoms/FlexBoxItem";
import { utilityColor } from "components/styles";
import Icon, { IconType } from 'components/atoms/Icon';
import BodyText from "components/atoms/BodyText";
const isIpad = window.matchMedia("(max-width: 1024px)").matches;

/**
 * プライマリボタン
 *
 * @see https://sketch.cloud/s/2b3Pe/a/k9qkrA
 */

interface RecorderButtonProps extends ButtonProps {
  icon: string,
  background: string,
  customStyle?: SerializedStyles
  textMin?: string
}

const styles = {
  textStyle: css({
    fontSize: isIpad ? '18px' : '24px',
    fontWeight: 700,
    color: 'white',
    marginLeft: isIpad ? '20px' : '30px'
  }),
  iconContainer: css({
    width: isIpad ? '40px' : '70px',
    alignSelf: 'flex-end',
    margin: '10px'
  }),
  content: css({
    justifyContent: "space-between",
    height: "100%",
    borderRadius: '3px'
  }),
  textMin: css({
    fontSize: '20px',
    color: 'white',
    fontWeight: 600,
    lineHeight: 0,
    marginLeft: '40px'
    })
}
const RecorderButton: React.FC<RecorderButtonProps> = ({
  text, textMin, onClick, icon, background, disabled, customStyle = css({})
}) => (
  <PrimaryButton
    text=""
    onClick={onClick}
    fullwidth={true}
    disabled={disabled}
    customStyle={css([{
      height: `${isIpad ? '80px !important' : '120px !important'}`,
      width: `${isIpad ? '230px !important' : '320px !important'}`,
      borderRadius: '3px',
      padding: '0',
      marginBottom: '20px'
    },
    css`
      svg{
        background-color: transparent;
        opacity: 0.7;
      }
    `,
    customStyle
  ])}
  >
    <FlexBox customStyle={css([styles.content, { backgroundColor: background }])}>
      <FlexBoxItem>
        <BodyText customStyle={css([styles.textStyle, {marginLeft : `${textMin ? '-10px': '30px'}`}])}>{text}</BodyText>
	      <p css={styles.textMin}>{textMin}</p>
      </FlexBoxItem>
      <FlexBoxItem customStyle={styles.iconContainer}>
        <Icon size={isIpad ? "35px" : "70px"} type={icon as IconType} color={utilityColor.white} />      
      </FlexBoxItem>
    </FlexBox>
  </PrimaryButton>
);

export default RecorderButton;
